export default function authHeader () {
  return {
    'Content-Type': 'application/json',

    Accept: '*/*'
  }
}
